export const NEW_LISTING_WINDOW_MS = 24 * 60 * 60 * 1000; // 24 hours

export const parseDateSafe = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    const ms = value.getTime();
    return Number.isNaN(ms) ? null : ms;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }
  try {
    const ms = Date.parse(value);
    return Number.isNaN(ms) ? null : ms;
  } catch (err) {
    return null;
  }
};

export const formatDurationShort = (milliseconds) => {
  if (typeof milliseconds !== "number" || !Number.isFinite(milliseconds)) {
    return null;
  }
  const clamped = Math.max(0, milliseconds);
  const totalSeconds = Math.floor(clamped / 1000);
  const totalMinutes = Math.floor(totalSeconds / 60);

  if (totalMinutes >= 60) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }

  if (totalMinutes >= 5) {
    return `${totalMinutes}m`;
  }

  if (totalMinutes >= 1) {
    const seconds = totalSeconds % 60;
    return seconds > 0 ? `${totalMinutes}m ${seconds}s` : `${totalMinutes}m`;
  }

  const seconds = Math.max(5, totalSeconds); // avoid showing 0s to users immediately
  return `${seconds}s`;
};

export const computeNewListingState = (collectedAt, now = Date.now()) => {
  const collectedAtMs = parseDateSafe(collectedAt);
  if (!collectedAtMs) {
    return {
      collectedAtMs: null,
      deadlineMs: null,
      msRemaining: 0,
      isNew: false,
    };
  }

  const deadlineMs = collectedAtMs + NEW_LISTING_WINDOW_MS;
  const msRemaining = Math.max(0, deadlineMs - now);
  return {
    collectedAtMs,
    deadlineMs,
    msRemaining,
    isNew: msRemaining > 0,
  };
};
